import type { StackProps } from "@mui/material"
import { Button } from "@mui/material"
import { cloneElement, type FC, type ReactElement } from "react"
import { v4 as uuid } from "uuid"

import { Actions } from "./styles"

interface Props {
	actions?: ReactElement[]
	actionWrapperProps?: StackProps
	onConfirm?: () => void
	onClose?: () => void
	cancelText?: string
	confirmText?: string
}
export const Footer: FC<Props> = ({
	actions,
	actionWrapperProps,
	cancelText,
	confirmText,
	onClose,
	onConfirm,
}) => {
	if (actions) {
		return (
			<Actions {...actionWrapperProps}>
				{actions.map(i => cloneElement(i, { key: uuid() }))}
			</Actions>
		)
	}

	if (cancelText && confirmText) {
		return (
			<Actions {...actionWrapperProps}>
				<Button
					variant='outlined'
					onClick={onClose}
					sx={{ textTransform: "none" }}
				>
					{cancelText}
				</Button>
				<Button
					color='secondary'
					variant='contained'
					onClick={onConfirm}
					sx={{ textTransform: "none" }}
				>
					{confirmText}
				</Button>
			</Actions>
		)
	}

	return null
}
